import { render } from "./DragAndDrop.vue?vue&type=template&id=41f510b8&scoped=true"
import script from "./DragAndDrop.vue?vue&type=script&lang=js"
export * from "./DragAndDrop.vue?vue&type=script&lang=js"

import "./DragAndDrop.vue?vue&type=style&index=0&id=41f510b8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-41f510b8"

export default script